import _classCallCheck from "/Users/francisco/Documents/GitHub/portfolio/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/francisco/Documents/GitHub/portfolio/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/francisco/Documents/GitHub/portfolio/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/francisco/Documents/GitHub/portfolio/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/francisco/Documents/GitHub/portfolio/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
import { initialConfig } from "./config";
import { Typing as LibTyping } from "./LibTyping";

var Typing = /*#__PURE__*/function (_React$Component) {
  _inherits(Typing, _React$Component);

  var _super = _createSuper(Typing);

  // eslint-disable-next-line no-useless-constructor
  function Typing(props) {
    _classCallCheck(this, Typing);

    return _super.call(this, props);
  }

  _createClass(Typing, [{
    key: "render",
    value: function render() {
      var text = this.props.text;
      return /*#__PURE__*/React.createElement(LibTyping, _extends({}, this.props, {
        key: text
      }));
    }
  }]);

  return Typing;
}(React.Component);

Typing.defaultProps = {
  typeSpeed: initialConfig.typeSpeed,
  suppressEmptyArray: initialConfig.suppressEmptyArray,
  ignoreInitialDelay: initialConfig.ignoreInitialDelay,
  element: initialConfig.element,
  styleClass: initialConfig.styleClass,
  letterSpacing: initialConfig.letterSpacing,
  cursorThickness: initialConfig.cursorThickness,
  cursorColor: initialConfig.cursorColor,
  cursorPadding: initialConfig.cursorPadding,
  shouldDelete: initialConfig.shouldDelete,
  deleteSpeed: initialConfig.deleteSpeed,
  blinkingSpeed: initialConfig.blinkingSpeed,
  disableBlinkingOnEnd: initialConfig.disableBlinkingOnEnd,
  smartBackspace: initialConfig.smartBackspace
};
export { Typing };